import { el, mount, unmount, setAttr } from '/lib/redom.es.js';

import CSSLoader from '/modules/css-loader/index.js';
import SVG from '/components/core/svg/index.js';

CSSLoader.load('/modules/self-destructing-message/index.css');

const types = {
  INFO: 'info',
  ERROR: 'error'
};

const liveMessagesList = [];

class SelfDestructingMessage {

  constructor(configuration) {

    this.height = null;
    this.destroyTimerReference = null;

    this.lifeTimeInSeconds = configuration.lifeTimeInSeconds;
    this.messageText = configuration.messageText;
    this.type = configuration.type;

    this.el = el('.self-destructing-message-main', {
      class: this.type
    }, [
      this.renderTypeIndicator(),
      this.renderMessage()
    ]);

  }

  onmount() {

    this.position();
    this.startDestroyTimer();

  }

  onunmount() {

    SelfDestructingMessage.repositionAll();

  }

  renderTypeIndicator() {

    if (this.type === types.INFO) {
      return new SVG({
        src: '/images/check-toast-icon.svg'
      });
    }

    return new SVG({
      src: '/images/close-toast-icon.svg'
    });

  }

  renderMessage() {

    return el('p.message-text', [this.messageText]);

  }

  destroyMessage() {

    clearTimeout(this.destroyTimerReference);

    const messageIndex = liveMessagesList.indexOf(this);

    liveMessagesList.splice(messageIndex, 1);

    unmount(document.body, this);

  }

  startDestroyTimer() {

    this.destroyTimerReference = setTimeout(this.destroyMessage.bind(this), this.lifeTimeInSeconds * 1000);

  }

  computeTopPosition() {

    const verticalSpacing = 5;
    let top = verticalSpacing;

    for (let message of liveMessagesList) {

      if (message === this) {
        break;
      }

      top += message.height + verticalSpacing;

    }

    return `${top}px`;

  }

  computeLeftPosition() {

    const left = (document.body.clientWidth / 2) - (this.width / 2);

    return `${left}px`;

  }

  position() {

    const boundingRectangle = this.el.getBoundingClientRect();

    this.width = boundingRectangle.width;
    this.height = boundingRectangle.height;

    const top = this.computeTopPosition();
    const left = this.computeLeftPosition();

    setAttr(this.el, {
      style: {
        top,
        left
      }
    });

  }

  static display(message) {

    liveMessagesList.push(message);

    mount(document.body, message);

  }

  static info(messageText, lifeTimeInSeconds = 5, clearPreviousNotifications = false) {

    if (clearPreviousNotifications === true) {
      SelfDestructingMessage.clearAll();
    }

    const message = new SelfDestructingMessage({
      messageText,
      lifeTimeInSeconds,
      type: types.INFO
    });

    SelfDestructingMessage.display(message);

  }

  static error(messageText, lifeTimeInSeconds = 5, clearPreviousNotifications = false) {

    if (clearPreviousNotifications === true) {
      SelfDestructingMessage.clearAll();
    }

    const message = new SelfDestructingMessage({
      messageText,
      lifeTimeInSeconds,
      type: types.ERROR
    });

    SelfDestructingMessage.display(message);

  }

  static repositionAll() {

    for (let message of liveMessagesList) {
      message.position();
    }

  }

  static clearAll() {

    for (let message of liveMessagesList) {
      message.destroyMessage();
    }

  }

}

window.SelfDestructingMessage = SelfDestructingMessage;

export default SelfDestructingMessage;